import {
  combineReducers,
  configureStore,
} from "@reduxjs/toolkit";
import { conversationApi } from "../services/conversation";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "../services/api";

// Store
import conversation from "./Conversation";

const reducers = combineReducers({
  conversation,
  [conversationApi.reducerPath]: conversationApi.reducer,
});

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

setupListeners(store.dispatch);
